import round from 'lodash-es/round'
/**
 * echart y轴数值转换
 * @param value
 */
export const yUnit = (value: number | string) => {
  const intValue = Number(value)
  if (typeof value === 'number') value = value.toString()
  const len = value.length
  if (len <= 6) return intValue
  else if (len >= 7 && len <= 9) return intValue / 1000000 + 'M'
  else if (len >= 10 && len <= 12) return intValue / 1000000000 + 'B'
  return intValue / 1000000000000 + 'T'
}

/**
 * 数值除以万
 * @param number
 */
export const numberTenThan = (number: number | string) => {
  return (Number(number) / 10000).toFixed(2) + '万'
}

// 数值单位转换
export function numConvert(num: any = 0, isEn = true) {
  // 中文数值单位转换（100000000 -> 1亿）
  function formatNumberCn(numcn: any = 0) {
    const { $i18n } = useNuxtApp()
    if (numcn < 10000) return round(numcn, 2)
    else if (numcn < 100000000)
      return $i18n.t('38581', ['{0}']).replace('{0}', (numcn / 10000)?.toFixed(2)) // 万
    else if (numcn < 1000000000000) return $i18n.t('38582', ['{0}']).replace('{0}', (numcn / 100000000)?.toFixed(2)) // 亿
    return $i18n.t('39020', ['{0}']).replace('{0}', (numcn / 1000000000000)?.toFixed(2)) // 万亿
  }
  // 英文数值单位转换（1000000 -> 1m）
  function formatNumberEn(numen: any = 0) {
    if (numen < 100000) return round(numen, 2)
    else if (numen < 1000000000) return (numen / 1000000)?.toFixed(2) + 'M'
    else if (numen < 1000000000000) return (numen / 1000000000)?.toFixed(2) + 'B'
    return (numen / 1000000000000)?.toFixed(2) + 'T'
  }
  num = Number(num) || 0
  return isEn ? formatNumberEn(num) : formatNumberCn(num)
}
